import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@theprelude/ds";

export const Route = createFileRoute("/verified")({
  component: VerifiedPage,
});

function VerifiedPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <header className="mx-6 border-b border-b-stroke-line pb-4 text-primary-foreground">
        Account verified successfully!
      </header>
      <img className="size-[18.75rem]" src="/images/bubbles.png" />
      <Link to="/home">
        <Button intent="secondary" className="mt-4">
          Go Home
        </Button>
      </Link>
    </div>
  );
}
